import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { JournalEnquirySection } from '@/features/ledger/journal-list'

/**
 * The journal enquiry, as an addressable screen of its own.
 *
 * Gated on `ledger.journal.view` by the section itself, not only by the navigation item that leads
 * here: the route is directly addressable and hiding a menu entry gates nothing.
 *
 * List and detail sit on one route rather than on a route each. `/ledger/journals` is registered in
 * the router and a parameterised child of it is not, so a typed link to `/ledger/journals/$id` would
 * not compile — and master-and-detail is the shape a reconciliation is worked in anyway.
 */
export function LedgerJournalsPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Journals"
        description="A posted entry is immutable. A correction is a reversal plus a fresh posting — never an edit — which is why nothing on this screen offers to change one."
      />

      <JournalEnquirySection />
    </>
  )
}
